export const AttributesToRetrieve = ['*', '-tokenizedName', '-tokenizedTagLine', '-summary', '-tags'];
export const EnterpriseAppsSectionMetaData = {
  id: 'enterpriseAppsSection',
  title: 'Cloud Fortified apps',
  description: "Cloud apps with additional security, reliability, and support to meet your organization's needs."
};